import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    name;
    status;
    disabled;
    formData = {
        name: this.$props.name,
        status: this.$props.status,
    };
    changeName(val) {
        this.$emit('update:name', val);
    }
    changeStatus(val) {
        this.$emit('update:status', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    get rules() {
        return {
            name: [{ required: true, message: `${this.$t('inputRule')}`, trigger: 'blur' }],
        };
    }
    get statusText() {
        if (this.formData.status === 'ENABLE') {
            return this.$t('active');
        }
        else {
            return this.$t('inactive');
        }
    }
};
__decorate([
    Prop({ default: '', type: String })
], default_1.prototype, "name", void 0);
__decorate([
    Prop()
], default_1.prototype, "status", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'NameAndStatus',
        components: {},
        i18n: {
            messages: {
                zh: {
                    taskName: '任务名称',
                    active: '启用',
                    inactive: '停用',
                    inputRule: '请输入任务名称',
                },
                'en-us': {
                    taskName: 'Task Name',
                    active: 'Activated',
                    inactive: 'Inactivated',
                    inputRule: 'Please enter task name',
                },
            },
        },
    })
], default_1);
export default default_1;
